import { cn } from '@/shared/lib/utils'
import {
  type InputBaseProps,
  type InputProps,
  type PasswordInputProps,
  PasswordInput,
} from '@mantine/core'
import type { FC, InputHTMLAttributes, ReactNode } from 'react'

export type InputPhoneSize = 'small' | 'medium' | 'large'

// type InputPasswordProps = InputBaseProps &
//   InputProps &
//   InputHTMLAttributes<HTMLInputElement> & {
//     label?: ReactNode
//     isOptional?: boolean
//     placeholder?: string
//     className?: string
//     isRequired?: boolean
//     sizeInput?: InputPhoneSize
//   }
type InputPasswordProps = PasswordInputProps &
  InputProps &
  InputHTMLAttributes<HTMLInputElement> & {
    label?: ReactNode
    isOptional?: boolean
    placeholder?: string
    className?: string
    isRequired?: boolean
    sizeInput?: InputPhoneSize
  }
const inputWrapperClassName = 'flex flex-col w-full '

const inputClassName =
  'border-gray/30 bg-white text-black focus-within:border-primary focus:border-primary autofill:bg-white disabled:bg-white disabled:opacity-50'

const innerInputClassName = ''

const inputSizeClassName: Record<InputPhoneSize, string> = {
  small: 'min-h-[1.875rem] rounded-md',
  medium: 'min-h-[2.5rem] rounded-md',
  large: 'min-h-[2.75rem] rounded-md',
}

export const InputPassword: FC<InputPasswordProps> = ({ isRequired, ...props }) => {
  const { placeholder, value, onChange, error, sizeInput = 'medium', ...restProps } = props

  const mergedInputGeneratorClassName = cn(inputClassName, inputSizeClassName[sizeInput])

  const mergedInnerInputClassNames = cn(inputSizeClassName[sizeInput])

  return (
    <div className={inputWrapperClassName}>
      <PasswordInput
        {...restProps}
        withAsterisk={isRequired}
        placeholder={placeholder}
        value={value as string}
        onChange={onChange}
        inputWrapperOrder={['label', 'input', 'description', 'error']}
        classNames={{
          root: 'leading-4 text-left',
          input: mergedInputGeneratorClassName,
          innerInput: mergedInnerInputClassNames,
          label: 'text-sm text-left font-medium whitespace-nowrap font-body leading-4 mb-2',
          error: 'mt-1',
          description: 'text-black/50',
        }}
        error={error}
      />
    </div>
  )
}
